import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ink py-16 sm:py-24" data-id="element-150" data-mp="122vbicn8knnw">
      <div className="mx-auto max-w-3xl px-4" data-id="element-151" data-mp="1prxupoxiqoki">
        <SectionHeading title={<>Frequently asked <span className="text-brand" data-id="element-153" data-mp="1urtxjkuhc9yh">questions</span></>} data-id="element-152" data-mp="1puajom1p1z72" />

        <div className="mt-10 space-y-3" data-id="element-154" data-mp="1utdihor2z96l">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-line bg-panel" data-id="element-155" data-mp="1l0zeepcj5qh9" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-4 text-left sm:p-5" data-id="element-156" data-mp="28qjyjbkf6ts4">
                  <span className="text-base font-bold text-white sm:text-lg" data-id="element-157" data-mp="2jr5r3dxg8r90">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-158" data-mp="2jpb47u2map2a" />
                </button>
                <AnimatePresence initial={false} data-id="element-159" data-mp="37foubf1n6du8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-160" data-mp="32iey9gjqz3xf">
                      <div className="space-y-2 px-4 pb-5 text-base leading-relaxed text-body sm:px-5" data-id="element-161" data-mp="1n1wnrwwyqs49">
                        {f.a.map(p => <p key={p} data-id="element-162" data-mp="1i44ylanpdk3r">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <CtaButton className="mt-12" label="All Clear — Get My Blueprint" data-id="element-163" data-mp="2gqcj0ysp4da3" />
      </div>
    </section>;
}